import { isPlatformBrowser, NgFor, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Inject, NgZone, OnDestroy, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { CategoryPageService } from '@app/_services/categoryPage.service';
import { HomepageService } from '@app/_services/homepage.service';
import { SharedService } from '@app/_services/shared.service';
import { SiteService } from '@app/_services/site.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { fromEvent, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { TranslateHelper } from '../../_helpers/translate-helper';
import { DirectionService } from '../../_services/direction.service';

@Component({
    selector: 'app-sectors-menu',
    templateUrl: './sectors-menu.component.html',
    styleUrls: ['./sectors-menu.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgFor, RouterLink, NgIf, TranslateModule]
})
export class SectorsMenu implements OnDestroy, OnInit {
    constructor(
        private sharedService: SharedService,
        private categoryPageService: CategoryPageService,
        private homepageService: HomepageService,
        private router: Router,
        public sitesService: SiteService,
        public translateHelper: TranslateHelper,
        public direction: DirectionService,
        public translate: TranslateService,
        private elementRef: ElementRef,
        private zone: NgZone,
        private cdr: ChangeDetectorRef,
        @Inject(PLATFORM_ID) private platformId: any,
    ) {
    }

    @Output() hasSelected: EventEmitter<boolean> = new EventEmitter();
    destroy$: Subject<void> = new Subject<void>();
    modelChanged: Subject<any> = new Subject<any>();
    selectedcategory;
    selectedIndex = new FormControl(0);
    subCategories: any = [];
    categoryColors: any = {};
    category;
    carouselOptions = {
        //items: 5,
        touchDrag: true,
        mouseDrag: true,
        skip_validateItems: true,
        margin: 8,
        autoWidth: true,
        rtl: this.direction.isRTL()
    };

    currentLang = this.translate.currentLang;

    categories = [];
    currentPage;
    categoriesOpen = false;
    hasProfessionals = false;
    private get element(): HTMLElement {
        return this.elementRef.nativeElement;
    }

    ngOnInit(): void {
        this.categoryPageService.categories$.pipe(takeUntil(this.destroy$)).subscribe((response) => {
            this.selectedIndex.setValue(0);
            this.subCategories = response;
            if (isPlatformBrowser(this.platformId)) {
                _.forEach(this.categories, (category, key) => {
                    let element = document.createElement('canvas');
                    let context = element.getContext("2d");
                    context.font = "15px Lato, sans-serif";
                    let fontSize = context.measureText(category?.name?.[this.translate.currentLang]).width;
                    this.categories[key].width = fontSize + 55;
                });
            }
        });

        this.categoryPageService.hasProfessionals$.pipe(takeUntil(this.destroy$)).subscribe((response) => {
            this.hasProfessionals = response;
        });

        this.categoryPageService.categoryColors$.pipe(takeUntil(this.destroy$)).subscribe((response) => {
            this.categoryColors = response;
        });

        this.sharedService.currentCategory$.pipe(takeUntil(this.destroy$)).subscribe((slug: any) => {
            if (slug) {
                this.selectedcategory = slug;
            } else {
                this.selectedcategory = null;
            }
        });

        this.sharedService.page$.pipe(takeUntil(this.destroy$)).subscribe((page) => {
            this.category = page;
            this.cdr.detectChanges();
        }, (error => {
            //console.log(error);
        }));

        this.modelChanged.pipe(debounceTime(300),distinctUntilChanged()).subscribe((event) => {
            if (event?.index > 0) {
                let category = this.categories[event?.index - 1]?.seo?.slug
                if (this.category && category) {
                    this.router.navigate(['/category', this.category, 'category', this.categories[event?.index - 1]?.seo?.slug]);
                    return;
                }
            }
        });

        this.sharedService.page$.subscribe(page => {
            this.currentPage = page;
        });

        if (isPlatformBrowser(this.platformId)) {
            this.zone.runOutsideAngular(() => {
                fromEvent<MouseEvent>(document, 'mousedown').pipe(
                    takeUntil(this.destroy$)
                ).subscribe((event) => {
                    let categoriesList = this.element.children.item(0).children.item(0);
                    if (!categoriesList.contains(event.target as HTMLElement)) {
                        this.zone.run(() => this.closeSectors());
                    }
                });
            });
        }

        this.categories = [];
        this.homepageService.categories$.subscribe(data => {
            if (!data) {
                return;
            }
            this.categories = data;
            if (isPlatformBrowser(this.platformId)) {
                _.forEach(this.categories, (category, key) => {
                    let element = document.createElement('canvas');
                    let context = element.getContext("2d");
                    context.font = "15px Lato, sans-serif";
                    let fontSize = context.measureText(category?.name?.[this.translate.currentLang]).width;
                    this.categories[key].width = fontSize + 55;
                });
            }
            // if (this.currentPage && this.currentPage != 'homepage') {
            //     let index = this.categories.findIndex(item => item.seo?.slug == this.currentPage);
            // }
            // this.cd.detectChanges();
        });
    }

    getSectorName() {
        let category = _.find(this.categories, ['seo.slug', this.currentPage]);
        return category?.name;
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    selectionChange(category) {
        if (this.category && category) {
            this.selectedcategory = category.seo?.slug;
            return;
        }
        
    }

    selectSector(category) {
        if (!category?.seo?.slug) {
            return false;
        }
        this.sharedService.pageSubject$.next(category?.seo?.slug);
    }

    categoryChange(event) {
        this.sharedService.currentCategorySubject$.next(null);
        this.selectSector(event);
        this.closeSectors();
        this.hasSelected.emit(true);
    }

    openSectors(): void {
        this.categoriesOpen = true;
    }

    closeSectors(): void {
        this.categoriesOpen = false;
    }

    toggleSectors(): void {
        this.categoriesOpen = !this.categoriesOpen;
    }
}
